import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Badge } from '@/components/ui/badge';
import type { KnowledgeReference } from '../../../types';
import {
  formatKnowledgeReferenceSnippet,
  getKnowledgeReferencePath,
  getKnowledgeReferenceTitle,
} from './drbfmTableFormat';

const KnowledgeReferenceCard: React.FC<{ reference: KnowledgeReference }> = ({ reference }) => {
  const { t } = useTranslation();
  const referenceTitle = getKnowledgeReferenceTitle(reference);
  const snippet = formatKnowledgeReferenceSnippet(reference.snippet);

  return (
    <div className="mb-2 rounded-md border p-3">
      <Link
        to={getKnowledgeReferencePath(reference)}
        className="revy-cjk text-sm font-medium leading-[1.5] text-primary underline-offset-4 hover:underline"
      >
        {referenceTitle}
      </Link>
      {reference.fileName && reference.fileName !== referenceTitle && (
        <p className="revy-cjk text-xs leading-[1.5] text-muted-foreground">{reference.fileName}</p>
      )}
      {snippet && (
        <p className="revy-cjk mt-1 whitespace-pre-wrap text-sm leading-[1.6] text-muted-foreground">
          {snippet}
        </p>
      )}
      <div className="mt-2">
        <Badge variant="secondary" className="revy-cjk revy-figure font-normal">
          {`${t('drbfm.knowledge.relevance')}: ${Math.round((reference.relevanceScore || 0) * 100)}%`}
        </Badge>
      </div>
    </div>
  );
};

export default KnowledgeReferenceCard;
